import { z } from "zod";

export const VerifyIdentitySchema = z.object({
  password: z.string(),
  otp: z.string(),
});

export type VerifyIdentitySchemaType = z.infer<typeof VerifyIdentitySchema>;
